import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface MailAddress {
  id: number
  address: string
  reserve: boolean
  newArrival: boolean
  remind: boolean
  notice: boolean
  event: boolean
  type: SystemCode
}

export function MailAddressFromJSON(json: any): MailAddress {
  return {
    id: json.id,
    address: exists(json, 'address') ? json.address : '',
    reserve: exists(json, 'reserve') ? json.reserve : false,
    newArrival: exists(json, 'new_arrival') ? json.new_arrival : false,
    remind: exists(json, 'remind') ? json.remind : false,
    notice: exists(json, 'notice') ? json.notice : false,
    event: exists(json, 'event') ? json.event : false,
    type: exists(json, 'type')
      ? SystemCodeFromJSON(json.type)
      : defaultSystemCode()
  }
}

export function MailAddressToJSON(value: MailAddress): any {
  return {
    id: value.id,
    address: value.address,
    reserve: value.reserve,
    new_arrival: value.newArrival,
    remind: value.remind,
    notice: value.notice,
    event: value.event,
    type: value.type.code
  }
}
